import React from 'react'

const PaperPlaneIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M1.5 10V2L11 6L1.5 10ZM2.5 8.5L8.425 6L2.5 3.5V5.25L5.5 6L2.5 6.75V8.5Z'
      fill='currentColor'
    />
  </svg>
)

export default PaperPlaneIcon
